// removed by extract-text-webpack-plugin
module.exports = {"filter-group-title":"src-lib-components-__FilterGroup__filter-group-title--xqthX","delete-button":"src-lib-components-__FilterGroup__delete-button--3zvpl","filter-group":"src-lib-components-__FilterGroup__filter-group--3JMNR","filter-group-content":"src-lib-components-__FilterGroup__filter-group-content--1acBE"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/FilterGroup.less
// module id = 1851
// module chunks = 0